import { Component, OnInit, Input } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.css']
})
export class SubHeaderComponent implements OnInit {
  @Input() title: string;

  constructor(private authService:AuthservicesService
  ) { }

  ngOnInit(): void {

    console.log(this.title,'dsadsad')
  }


  redirect() {
    this.authService.goBack()
  }

}
